import type { FunctionComponent } from 'react';
import { useSuburbPageQuery } from '../../graphql/useSuburbPageQuery';
import { SuburbPageNearbySchoolsBrick } from './SuburbPageNearbySchoolsBrick';
import { ResultOf } from 'gql.tada';
import { suburbPageQuery } from '../../graphql/suburbPageQuery';
import { mapApiWeblinkVariantToLinkVariant } from '../../../app-kit/helpers/mapApiWeblinkVariantToLinkVariant';
import { School } from '../../../components/SchoolsAccordionTable/types';
import { mapApiWeblinkIconInfoToLinkIconInfo } from '../../../app-kit/helpers/mapApiWeblinkIconInfoToLinkIconInfo';
import { mapApiButtonVariantToButtonVariant } from '../../../app-kit/helpers/mapApiButtonVariantToButtonVariant';

type ApiSuburbPageSchool = NonNullable<
  NonNullable<
    NonNullable<ResultOf<typeof suburbPageQuery>['suburbPageBySlug']>['nearbySchools']
  >[number]['schools']['visible'][number]
>;

const mapApiSchoolToSchoolProp = (school: ApiSuburbPageSchool): School => {
  return {
    ...school,
    webLinks: school.webLinks
      ? school.webLinks.map((webLink) => ({
          ...webLink,
          variant: mapApiWeblinkVariantToLinkVariant(webLink.variant),
          iconInfo: webLink.iconInfo ? mapApiWeblinkIconInfoToLinkIconInfo(webLink.iconInfo) : null,
        }))
      : [],
  };
};

export const SuburbPageNearbySchoolsBricksWithData: FunctionComponent = () => {
  const nearbySchools = useSuburbPageQuery()?.data?.suburbPageBySlug?.nearbySchools;
  if (!nearbySchools) return null;

  return (
    <>
      {nearbySchools.map(
        ({ title, schools: { visible, hidden }, schoolFactHeader, showAllButton }) => {
          return (
            <SuburbPageNearbySchoolsBrick
              key={title}
              title={title}
              visible={visible.map(mapApiSchoolToSchoolProp)}
              hidden={hidden ? hidden.map(mapApiSchoolToSchoolProp) : null}
              schoolFactHeader={schoolFactHeader}
              showAllButton={
                showAllButton
                  ? {
                      text: showAllButton.text,
                      variant: mapApiButtonVariantToButtonVariant(showAllButton.buttonVariant),
                    }
                  : null
              }
            />
          );
        },
      )}
    </>
  );
};
